import { useCallback } from 'react'

import { useAuth } from '@clerk/nextjs'
import { configureScope } from '@sentry/nextjs'

import { removeUserIdFromLocalStorage } from 'domains/user/user.storage'
import { resetToken } from 'graphql/urql.auth'
import { toasty } from 'store/toasts.state'

const useLogout = () => {
  const { signOut } = useAuth()

  const logout = useCallback(async () => {
    try {
      // Logout from Clerk
      await signOut()
      resetToken()
    } catch (error) {
      return toasty.error({
        title: 'Error',
        text: 'There was an error logging you out. Please try again.'
      })
    }

    // Remove user metadata from local storage
    removeUserIdFromLocalStorage()

    try {
      // Cleanup RudderStack
      window.rudderanalytics?.reset()
      // Clear Sentry User
      configureScope(scope => scope.setUser(null))
    } catch {
      // Skip errors
    }

    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { logout }
}

export default useLogout
